import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {collapseIframe, collapseIframeAndExpandWallet} from "../../../../widget/misc/WidgetUtils";
import {BasePanelPage, BasePanelPageStyle} from "../BasePanelPage";
import {PaymentSucceededIcon} from "../../../../SVGElements";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {userService} from "../../../../../client/connection/Services";
import {Perk} from "../subscribe/components/CoverageDescriptionElements";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {iFrameState} from "../../../../services/IFrameState";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";


export class DonationSuccessPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: iFrameMerchantService.isMerchant(TNR_ALIAS) ? "left" : "center",
    };

    @styleRule
    icon = {
        marginBottom: 14,
        textAlign: "center",
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
        marginBottom: 14,
    };

    @styleRule
    guideline = {
        marginBottom: 14,
    };
}

@registerStyle(DonationSuccessPanelStyle)
export class DonationSuccessPanel extends BasePanelPage {
    getMessageTop() {
        const donation = iFrameUserDataService.getLatestDonation();
        const merchantName = iFrameMerchantService.getMerchant().getName();
        const email = userService.getUserEmail();

        if (donation.isRecurring()) {
            return Messages.donateThankYouMessageRecurring(merchantName, email)
        }
        return Messages.donateThankYouMessageOneTime(merchantName, email);
    }

    getMessageTitle() {
        const donation = iFrameUserDataService.getLatestDonation();

        if (donation.isRecurring()) {
            return Messages.donateThankYouTitleRecurring(donation.formatPrice());
        }
        return Messages.donateThankYouTitleOneTime(donation.formatPrice());
    }

    getGuidelines() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getLatestDonation();

        if (iFrameState.forceHideWallet) {
            return null;
        }

        if (donation.isRecurring()) {
            return [
                <Perk text={Messages.donateThankYouRecurringGuideline1} className={styleSheet.guideline}/>,
                <Perk text={Messages.donateThankYouRecurringGuideline2} className={styleSheet.guideline}/>,
            ];
        }
        return [
            <Perk text={Messages.donateThankYouOneTimeGuideline1} className={styleSheet.guideline}/>,
            <Perk text={Messages.donateThankYouOneTimeGuideline2} className={styleSheet.guideline}/>,
        ];
    }

    render() {
        const {styleSheet} = this;

        return [
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null : <PaymentSucceededIcon className={styleSheet.icon}/>,
            <MessageElement testId="donateModalThankYouTitle" className={styleSheet.title} message={this.getMessageTitle()}/>,
            <MessageElement testId="donateModalThankYouMessage1" className={styleSheet.message} message={this.getMessageTop()}/>,
            <div testId="donateModalThankYouMessage2" className={styleSheet.message}>{Messages.donateThankYouBottomMessage}</div>,
            this.getGuidelines(),
            <MerchantButton className={styleSheet.button} onClick={collapseIframe}>
                {Messages.ok}
            </MerchantButton>,
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null :
                <div className={styleSheet.center}>
                    <div className={styleSheet.secondaryButton} onClick={collapseIframeAndExpandWallet}>{Messages.manageMyAccount}</div>
                </div>,
        ];
    }
}
